import React, { Suspense } from 'react';
import JumboApp from '@jumbo/components/JumboApp';
import AppLayout from './AppLayout';
import JumboTheme from '@jumbo/components/JumboTheme';
import AppRoutes from './AppRoutes';
import { SnackbarProvider, useSnackbar } from 'notistack';
import AppProvider from './AppProvider';
import { config } from './config/main';
import JumboRTL from '@jumbo/JumboRTL/JumboRTL';
import Div from '@jumbo/shared/Div';
import { CircularProgress, IconButton } from '@mui/material';
import CancelIcon from '@mui/icons-material/Cancel';

function SnackbarCloseButton({ snackbarKey }) {
  const { closeSnackbar } = useSnackbar();
  return (
    <IconButton onClick={() => closeSnackbar(snackbarKey)}>
      <CancelIcon sx={{ color: '#ffffff' }} />
    </IconButton>
  );
}
function App() {
  return (
    <AppProvider>
      <JumboApp activeLayout={config.defaultLayout}>
        <JumboTheme init={config.theme}>
          <JumboRTL>
          <SnackbarProvider
                hideIconVariant
                action={(snackbarKey) => <SnackbarCloseButton snackbarKey={snackbarKey} />}
                anchorOrigin={{
                  vertical: 'top',
                  horizontal: 'right',
                }}
                maxSnack={3}
                autoHideDuration={4000}>
              <AppLayout>
                <Suspense
                  fallback={
                    <Div
                      sx={{
                        display: 'flex',
                        minWidth: 0,
                        alignItems: 'center',
                        alignContent: 'center',
                        height: '100%',
                      }}
                    >
                      <CircularProgress sx={{ m: '-40px auto 0' }} />
                    </Div>
                  }
                >
                  <AppRoutes />
                </Suspense>
              </AppLayout>
            </SnackbarProvider>
          </JumboRTL>
        </JumboTheme>
      </JumboApp>
    </AppProvider>
  );
}

export default App;
